import { render } from "./CategoryDetail.vue?vue&type=template&id=0463baa4"
import script from "./CategoryDetail.vue?vue&type=script&lang=js"
export * from "./CategoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__